module.exports = __webpack_public_path__ + "img/bg_00.186ed94c.png";